import * as Sentry from "@sentry/react";
import config from "./config";

const dsn = config.SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
  });
}
